import Helper from './Helper';

class InteractiveGraphic {
  constructor() {
    this.interactiveLinks = document.querySelectorAll('.interactive-graphic-link');
    this.interactiveLinksArray = Array.prototype.slice.call(this.interactiveLinks);

    this.bindEvents();
  }

  bindEvents() {
    this.interactiveLinksArray.forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        var link = toggle.getAttribute('data-url');

        if (!link.includes(window.location.hostname)) {
          window.open(link, '_blank');
        } else {
          window.open(link, '_self');
        }
        // window.location.replace(toggle.getAttribute('data-url'));
      });
    });
  }
}

export default InteractiveGraphic;
